import * as jsonpatch from 'fast-json-patch';

const STRING = 'string';
    
const patchHelper = (patcher, base, { diff } = {}) => patcher.applyPatch(base, diff);

class PatchWorker {
    constructor (instance) {
        this.patcher = jsonpatch;
        this.patchTarget = instance;
    }

    diff (update) {
        return {
            diff: this.patcher.diff_main(this.patchTarget.dataString, update)
        };
    };

    make_patch (update) {
        return {
            patch: this.patcher.patch_make(this.patchTarget.dataString, this.diff(update).diff)
        };
    };

    patch (diffs) {
        if (typeof diffs === STRING) {
            diffs = JSON.parse(diffs);
        }
        if (!Array.isArray(diffs)) {
            diffs = [diffs];
        }
        let i = 0;
        let patched = this.patchTarget.data;
        const len = diffs.length;

        for (; i < len; i++) {
            patched = patchHelper(this.patcher, patched, diffs[i]);
        }

        return patched.newDocument;
    };
};

export default PatchWorker;
